export enum NotificationToastKind {
  Default = '',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Primary = 'primary',
  Secondary = 'secondary',
  Light = 'light',
  Dark = 'dark'
}
